export const GET_LINK_DOCUMENT = "/v1/document-batches/generate-upload-link";
export const GET_LINK_ACUSE = "/v1/receipt-accuse/generate-upload-link";
export const PROCESS_DOCUMENT_BATCH = "/v1/document-batches";
export const PROCESS_RECEIPT_ACCUSE = "/v1/receipt-accuse";
export const GET_ELECTRONIC_DOCS = "/v1/electronic-documents";
export const GET_ELECTRONIC_DOCS_PAGE = "/v1/electronic-documents/page";
export const GET_ELECTRONIC_RIPS = "/v1/electronic-rips";
export const GET_DATA_PROVIDER = "/v1/health-service-providers";
export const GET_DATA_STATES_DOCS =
  "/v1/master-records/ELECTRONIC_DOCUMENT_STATES";
export const GET_DATA_TYPES_DOCS =
  "/v1/master-records/ELECTRONIC_DOCUMENT_TYPE";
export const GET_DATA_USER_TYPES_DOC = "v1/master-records/IDENTIFICATION_TYPES";
export const GET_DATA_PAYMENT_LINE =
  "/v1/master-records/ELECTRONIC_DOCUMENT_PAYMENT_LINE";
export const GET_DATA_SUPPORT_CONTAINER =
  "/v1/master-records/SUPPORT_CONTAINER";
export const GET_ACTIVITY_STATUS = "/v1/master-records/ACTIVITY_STATUS";
export const GET_TYPE_HEALTH_PROVIDER =
  "/v1/master-records/HEALTH_SERVICE_PROVIDER_TYPE";
export const GET_AUDIT_RESTART_CRITERIA =
  "/v1/master-records/AUDIT_RESTART_CRITERIA";
export const GET_DATA_PROVINCES = "/v1/provinces";
export const GET_DATA_PAYMENTS_STATES =
  "v1/master-records/PAYMENT_AUTHORIZATION_STATES";
export const GET_EVENTS_HISTORY = "/v1/events_history";
export const REPORTS = "/v1/custom-reports";
export const ACCOUNTANT_REPORT_EXPORT =
  "/v1/custom-reports/export/accountant-report";
export const EXPORT_PAYMENTS = "download_payments";
export const GET_ELECTRONIC_SUPPORTS = "/supports/associated-support";
export const GET_ELECTRONIC_DOCUMENTS_RELATED = "/related-documents";
export const ELECTRONIC_SUPPORTS_DOWNLOAD = "/supports/download";
export const ELECTRONIC_SUPPORTS_DOWNLOAD_SINGLE =
  "/supports/download-individual-support";
export const ELECTRONIC_SUPPORTS_DOWNLOAD_SINGLE_BASE64 =
  "supports/download-individual-support-base64";
export const ELECTRONIC_SUPPORTS_DOWNLOAD_NC =
  "/supports/download-individual-pdf-base64";
export const GET_DATA_NOTIFICATIONS = "/v1/notifications/by-user";
export const UPDATE_DATA_NOTIFICATIONS = "/v1/notifications/update";
export const GET_DATA_MASTER_GLOSSAS = "/v1/glosses/master-glosses";
export const DOCUMENT_GLOSSAS = "/v1/glosses/electronic-documents";
export const CREDIT_NOTES_ADDED = "/v1/glosses/link-credit-note";
export const RESULT_ACCEPT_VALUE = "/v1/glosses/result-accepte-value";
export const PAYMENT_AUTHORIZATION = "v1/payment-authorization";
export const GLOSSES_ANSWER = "v1/glosses/answer";
export const GLOSSES_AUDIT = "v1/glosses/audit-consolidate";
export const POST_PAYMENT_AUTHORIZATION_DETAILS = "/v1/payment-authorization";
export const GET_BALANCE_HISTORY = "/balance-history";
export const GLOSSES_CONSOLIDATE = "v1/glosses/audit-consolidate";
export const GLOSSES = "v1/glosses";
export const GET_COMMENTS = "/v1/comments";
export const GET_CONTACT_NUMBER = "/v1/contract-numbers";
export const WEBSITES = "/v1/websites";
export const TACIT_CONSOLIDATED = "/v1/glosses/tacit-consolidated";
export const GET_DATA_YEAR = "/v1/master-records/YEAR";
export const GET_DATA_MONTH = "/v1/master-records/MONTH";
export const GET_CONTRACTS_NUMBER = "v1/contract-numbers/page";
export const GET_VALIDATE_FILE =
  "/v1/electronic-documents/supports/validar-checksum";
export const VALIDATE_PAYMENT_SUPPORT = "/v1/payment/validate-payment-batch";
export const REGISTER_PAYMENT_SUPPORT = "/v1/payment/register-payment-batch";
export const DOWNLOAD_PAYMENT_SUPPORT =
  "/v1/payment/download-individual-payment_document-base64";
export const DATA_PAYMENT_SUPPORT = "/v1/payment/related-documents";
export const DOWNLOAD_PAYMENT_ATTACHMENTS =
  "/v1/payment/download-payment-attachments";
export const FIND_PAYMENT_BY_ELECTRONIC_DOCUMENT = "/v1/payment/find-by-electronic-document";
export const GENERATE_UPLOAD_LINK_PAYMENT =
  "/v1/payment/generate-upload-link-payment";
export const GENERATE_UPLOAD_LINK_RESTART_PAYMENT_PACKAGE =
  "/v1/payment/generate-upload-link-restart-payment-package";
export const GENERATE_UPLOAD_LINK_RESOLUTION_DOCUMENT =
  "/v1/payment/generate-upload-link-resolution-document";
export const RESTART_PAYMENT_PACKAGE =
  "/v1/payment/restart-payment-package";
export const EXECUTE_RESTART_PAYMENT_PACKAGE =
  "/v1/payment/restart-payment-package/execute";
export const PAYMENT_SUMMARY = "/v1/payment/payment-summary";
export const EXPORT_PAYMENTS_ZIP = "/v1/payment/download-payment-package";
export const DOWNLOAD_PAYMENT_PACKAGE = "/v1/payment/download-payment-package";
export const DOWNLOAD_DRAFT_RESOLUTION = "/v1/payment/download-draft-resolution";
export const GET_VALIDATE_FILE_RIPS = "ws/rips-validation";
export const GET_DATA_CONTRACT_STATUS = "/v1/master-records/CONTRACT_STATE";
export const GET_PAYMENT_PACKAGE_STATES = "/v1/master-records/PAYMENT_PACKAGE_STATE";
export const GET_DATA_USERS_PROVIDERS_CORE = "v1/health-service-providers";
export const GET_DATA_USERS_TOKEN = "/v1/oauth2/token";
export const GET_DATA_USERS = "/v1/users";
export const PROVISION_ELECTRONIC_DOCS =
  "/v1/provision/electronic-documents/provision";
export const GET_SAP_FAILED_PROVISIONS =
  "/v1/api/edocument/sap-failed-provisions";
export const GET_PROVISION_HISTORY = "/v1/provision";

export const DEDUCTIONS = "/v1/deductions";
export const DEDUCTIONS_PROVIDERS = "/v1/deductions-providers";
export const COST_CENTERS = "/v1/cost-centers";
export const COST_CENTER_STATES = "/v1/master-records/COST_CENTER_STATES";
export const FINANCIAL_PROCESS = "/financial-process";
export const PAGE_PAYMENT_PACKAGE = "/v1/payment/page-payment-package";
export const DETAIL_PAYMENT_PACKAGE = "/v1/payment/detail-payment-package";
export const AUDITOR_SIGNATURE = "/v1/users/me/auditor-signature";
export const REGISTER_SINGLE_PAYMENT = "/v1/payment/register-single-payment";
export const UPDATE_PAYMENT_PACKAGE = "/v1/payment/update-payment-package";

export * from './services';
